import { Component } from '@angular/core';

@Component({
    templateUrl: '404.component.html'
})
export class P404Component {

    constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/sujay/crpanel/crpanel/backend/backend/src/app/pages/404.component.ts